import React, { useState } from 'react';
import StarField from './StarField';
import ImageLightbox from './ImageLightbox';

const CurrentProjectsSection = () => {
  const [lightboxImage, setLightboxImage] = useState(null);

  const projects = [
    {
      name: '"Oras" Blue Luminous GMT Mod',
      features: ['Black PVD Case', 'Custom Baybayin Script Dial', 'GMT Function', 'Nylon Strap'],
      image: 'https://customer-assets.emergentagent.com/job_santiago-timepieces/artifacts/91icp11j_oras-mod.png',
    },
    {
      name: 'Coming Soon...',
      features: [],
      image: null,
    },
  ];

  return (
    <section id="current-projects" className="py-24 bg-black relative overflow-hidden">
      <StarField density="sparse" />
      <div className="container mx-auto px-6 max-w-6xl relative z-10">
        {/* Section Header */}
        <div className="mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-white mb-4 tracking-tight">
            Current Projects
          </h2>
          <div className="w-20 h-1 bg-white"></div>
          <p className="text-gray-400 font-light mt-4">
            Watch builds currently in development
          </p>
        </div>

        {/* Projects Grid - 2 cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {projects.map((project, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 hover:bg-white/10 hover:border-white/30 hover:shadow-[0_0_40px_rgba(255,255,255,0.15)] hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="aspect-square bg-white/5 mb-6 flex items-center justify-center group-hover:bg-white/10 transition-colors duration-300 overflow-hidden relative">
                {project.image ? (
                  <>
                    <img
                      src={project.image}
                      alt={project.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    {/* Coming soon overlay */}
                    <div className="absolute inset-0 bg-gray-900/60 backdrop-blur-[2px] flex items-center justify-center pointer-events-none">
                      <span className="text-gray-300 font-light text-lg tracking-wide">
                        Coming Soon...
                      </span>
                    </div>
                  </>
                ) : (
                  <div className="text-gray-500 font-light text-lg tracking-wide">
                    Coming Soon...
                  </div>
                )}
              </div>
              {project.image && (
                <>
                  <h3 className="text-xl md:text-2xl font-medium text-white mb-4">{project.name}</h3>
                  <div className="space-y-2">
                    {project.features.map((feature, idx) => (
                      <div key={idx} className="text-sm text-gray-400 flex items-center font-light">
                        <span className="w-1.5 h-1.5 bg-white/60 rounded-full mr-3"></span>
                        {feature}
                      </div>
                    ))}
                  </div>
                </>
              )}
              {!project.image && (
                <h3 className="text-xl md:text-2xl font-medium text-gray-400 mb-4">{project.name}</h3>
              )}
            </div>
          ))}
        </div>
      </div>

      <ImageLightbox
        src={lightboxImage?.src}
        alt={lightboxImage?.alt}
        isOpen={!!lightboxImage}
        onClose={() => setLightboxImage(null)}
      />
    </section>
  );
};

export default CurrentProjectsSection;
